import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import fetch from 'isomorphic-fetch';
import base64url from 'base64url';
import { onError } from "@apollo/client/link/error";

const customFetch = (uri, options) => {
  try {
    let local_access_token = ""
    let encoded_token = ""

    const inflowkit_customer_id = `${typeof window !== 'undefined' &&
      window.localStorage.getItem('in_cid')}`;
    const inflowkit_customer_email = `${typeof window !== 'undefined' &&
      localStorage.getItem('in_email')}`;

    const inflowkit_access_token = process.env.TOKEN;

    const token = base64url.encode(
      `${inflowkit_customer_id},${inflowkit_customer_email},${inflowkit_access_token}`
    );

    //Get access token 
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href);
      if (url.searchParams.has('token')) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const url_token = urlParams.get('token')

        //If token is there store in the localstorage 
        if (url_token) {
          //Update the local storange
          localStorage.setItem('inflowkit_access_token', url_token);
        }
      }
    }
    local_access_token = localStorage.getItem('inflowkit_access_token');

    encoded_token = base64url.encode(`${local_access_token}`)

    return fetch(`${process.env.GATSBY_API_URL}?token=${token}&access_token=${encoded_token}`, options).catch(error => {
      // if (typeof window != "undefined") {
      //   window.open(
      //     `https://${window.location.hostname}/a/courses/home/login`,
      //     "_self"
      //   )
      // }

    });
  } catch (error) {

    if (typeof window != "undefined") {
      if (window.location.pathname != "/a/courses/home/available/") {
        //Check whether guest accounts are enabled 
        if (process.env.ENABLE_GUEST_ACCOUNT == "false") {
          localStorage.setItem("in_redirect", `https://${window.location.hostname}/a/courses/home`)
          window.open(`${window.inflowkit_login_url}?in_redirect_value=1`, "_self")

        } else {
          window.open(
            `https://${window.location.hostname}/a/courses/home/login`,
            "_self"
          )
        }
      }
    }
  }
};

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({ fetch: customFetch }),
  request: operation => {
    operation.setContext({
      fetchOptions: {
        credentials: 'include',
      },
    });
  },
  onError: error => {
    console.log(error)
  },
});
